import Column from '@app/components/layout/Column'
import { useTranslations } from '@i18n/useLanguage'
import { TabsGroup } from '@app/components/core/tabs/Tabs'
import { match } from 'ts-pattern'
import { Overview } from './Overview'
import { Thread } from '../../../../components/blocks/thread/Thread'
import { useParamState } from '@app/util/hooks/useParamState'
import { ViewInitiativeModel } from 'functions/app/initiative/view'
import { initiativeTabs } from './initiativeTabs'
import { Events } from './Events'

export const TabContent = ({
  initiative,
}: {
  initiative: ViewInitiativeModel
}) => {
  const translations = useTranslations().app.initiativePage
  const [tab, setTab] = useParamState(initiativeTabs)
  return (
    <Column alignItems="stretch" gap="2rem">
      <TabsGroup
        selectedTab={tab}
        onSelectTab={setTab}
        tabs={[
          { label: translations.overview, value: initiativeTabs.overview },
          { label: translations.thread, value: initiativeTabs.discussion },
          { label: translations.events, value: initiativeTabs.events },
        ]}
      />
      {match(tab)
        .with(initiativeTabs.overview, () => (
          <Overview key={initiativeTabs.overview} initiative={initiative} />
        ))
        .with(initiativeTabs.discussion, () =>
          initiative.thread?.id ? (
            <Thread
              key={initiativeTabs.discussion}
              threadId={initiative.thread.id}
            />
          ) : null,
        )
        .with(initiativeTabs.events, () => (
          <Events key={initiativeTabs.events} initiativeId={initiative.id} />
        ))
        .exhaustive()}
    </Column>
  )
}
